import React from 'react';
import classNames from 'classnames';
import { COLOR_VARIANT, ColorVariants } from 'models/Colors';

import './Tag.styles.scss';

type TagProps = {
  className?: string;
  content: string;
  variant?: ColorVariants;
};

const Tag: React.FC<TagProps> = (props) => {
  const { className, content, variant = COLOR_VARIANT.BLUE } = props;

  const classes = classNames('portfolio-tag', variant, className);

  return <p className={classes}>{content}</p>;
};

export default Tag;
